import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import DOMPurify from 'dompurify';

import { Button } from '../../../helpers'
import SendEmail from "../../../common/SendEmail";

import { getFullName } from '../../../utils'


const ConfirmGenerateInvoice = (props) => {
    const { throttledGenerateBuyerEInvoice, buyerUserDetails, clientBranchEmailCCMap } = props

    const userNameDetails = useSelector(state => state.userDetails.userNameDetails)
    
    const [emailDetailsObj, setEmailDetailsObj] = useState({})
    const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false)

    let clientCCEmails = []
    if(clientBranchEmailCCMap && clientBranchEmailCCMap.emailIds){
        clientCCEmails = clientBranchEmailCCMap.emailIds
    }

    const handleSendMailandGenerateEInvoice = () => {
        let htmlString = `
            <div style="font-family: Arial, sans-serif; line-height: 1.2;">
                <img alt="ProcMart Logo" src="https://procmart-dev.s3.ap-south-1.amazonaws.com/logo.png" style="margin-bottom: 10px;"><br/>
                <p>Dear ${getFullName(buyerUserDetails.firstName)},</p>
                <p>Greetings from ProcMart!</p>
                <p>We are pleased to inform you that your order has been dispatched. Please find the attached document below for your reference.</p> <br/>
                <p>Best regards,</p>
                <p>${getFullName(userNameDetails.firstName, userNameDetails.lastName)}</p>
            </div>
        `
        let sanitizedHTML = DOMPurify.sanitize(htmlString)
        const emailDetailObj = {
            to: buyerUserDetails.emailId,
            from: userNameDetails.emailId,
            kam: userNameDetails.emailId,
            subject: `Order Dispatched by Procmart`,
            message: sanitizedHTML,
            cc: clientCCEmails
        }
        setEmailDetailsObj(emailDetailObj)
        setIsEmailDialogVisible(true)
    }

    const handleGenerateOnlyEInvoice = () => {
        throttledGenerateBuyerEInvoice()
    }

    return (
        <div>
            <div className="flex flex-row align-items-start">
                Confirm to generate E-invoice?
            </div>
            <div className="flex flex-row justify-content-center mt-5">
                <Button label="Generate E-Invoice and Send Mail" onClick={handleSendMailandGenerateEInvoice} />
                <Button className="ml-2" label="Generate Only E-Invoice"  onClick={handleGenerateOnlyEInvoice} />
            </div>
            <SendEmail emailDetailsObj={emailDetailsObj} visible={isEmailDialogVisible} handleSendMail={throttledGenerateBuyerEInvoice} setEmailDetailsObj={setEmailDetailsObj} onHide={() => setIsEmailDialogVisible(false)}/>
        </div>
    )
}

export default ConfirmGenerateInvoice
